<template>
    <div class="container">
        <div class="breadcrumb">
            <a @click="$router.go(-1)">意见反馈 </a>
            <span> / 反馈详情</span>
            <span> : {{ feedType }}</span>
        </div>
        <div class="detail">
            <div class="detail-row">
                <div>
                    <div class="detail_item_title">
                        <span>账</span>
                        <span>号</span>
                    </div>
                    <span>{{ username }}</span>
                </div>
                <div>
                    <div class="detail_item_title big">
                        <span>时</span>
                        <span>间</span>
                    </div>
                    <span>{{ formatDate(createdAt, "y-M-d h:m:s") }}</span>
                </div>
            </div>
            <div class="detail-row">
                <div>
                    <div class="detail_item_title">
                        <span>联</span>
                        <span>系</span>
                        <span>电</span>
                        <span>话</span>
                    </div>
                    <span>{{ contact }}</span>
                </div>
                <div>
                    <div class="detail_item_title big">
                        <span>小</span>
                        <span>程</span>
                        <span>序</span>
                        <span>版</span>
                        <span>本</span>
                    </div>
                    <span>{{ appVersion }}</span>
                </div>
            </div>
            <div class="detail-row">
                <div>
                    <div class="detail_item_title">
                        <span>手</span>
                        <span>机</span>
                        <span>类</span>
                        <span>型</span>
                    </div>
                    <span>{{ phoneType }}</span>
                </div>
                <div>
                    <div class="detail_item_title big">
                        <span>系</span>
                        <span>统</span>
                        <span>版</span>
                        <span>本</span>
                    </div>
                    <span>{{ systemVersion }}</span>
                </div>
            </div>
            <div class="detail-row-file">
                <div class="detail_item_title">
                    <span>截</span>
                    <span>图</span>
                </div>
                <div class="imgList" ref="images" @click.capture="showImg">
                    <a v-for="(item, index) in images" :key="index">
                        <img :src="item" alt="" />
                    </a>
                    <div class="noImage" v-if="!images.length">无</div>
                </div>
            </div>
            <div class="detail-row-content">
                {{ parseEmoji(content) }}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            id: "",
            username: "",
            createdAt: "",
            contact: "",
            appVersion: "",
            phoneType: "",
            systemVersion: "",
            images: [],
            content: "",
            feedType: "",
        };
    },
    methods: {
        parseEmoji(data) {
            if (!data || data.indexOf("\\u") == -1) return data;
            data = data.split("\\u");
            var str = "";
            for (var i = 1; i < data.length; i++) {
                str += String.fromCharCode(parseInt(data[i], 16).toString(10));
            }
            return str;
        },
        showImg() {
            layer.photos({
                photos: this.$refs.images,
                anim: 5,
            });
        },
    },
    created() {
        console.log(this.$route.query);
        if (this.$route.query.id) {
            this.feedType = this.$route.query.type;
            this.id = this.$route.query.id;
            this.username = this.$route.query.username;
            this.contact = this.$route.query.contact;
            this.appVersion = this.$route.query.appVersion;
            this.phoneType = this.$route.query.phoneType;
            this.systemVersion = this.$route.query.systemVersion;
            this.content = this.$route.query.content;
            this.createdAt = this.$route.query.createdAt;
            if (this.$route.query.annexes) {
                this.images = this.$route.query.annexes;
            }
        }
    },
};
</script>
<style lang="scss" scoped>
.detail {
    width: 100%;
    padding: 30px 15%;
    box-sizing: border-box;
}
.detail-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    color: #666;
    & > div {
        width: 48%;
        padding-left: 10px;
        display: flex;
        align-items: center;
    }
    .detail_item_title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100px;
        &::before {
            content: "【";
        }
        &::after {
            content: "】";
        }
    }
    .detail_item_title.big {
        width: 120px;
    }
}
.detail-row-file {
    padding: 20px 10px;
    display: flex;
    align-items: flex-start;
    color: #666;
    .imgList {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        img {
            height: 200px;
            margin-right: 10px;
            margin-bottom: 10px;
        }
        .noImage {
            padding-top: 5px;
        }
    }
    .detail_item_title {
        flex: 0 0 100px;
        padding-top: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &::before {
            content: "【";
        }
        &::after {
            content: "】";
        }
    }
}
.detail-row-content {
    border: 1px solid #ccc;
    height: 250px;
    margin: 10px 20px;
    box-sizing: border-box;
    padding: 10px;
    overflow: auto;
}
@media only screen and (max-width: 1600px) {
    .container {
        width: 90%;
    }
}
</style>
